import Swal from 'sweetalert2';

class Alert {
  constructor({
    type = 'normal',
    message = '',
    html = '',
    buttons = [],
    classes = '',
    icon = '',
  } = {}) {
    this.type = type;
    this.message = message;
    this.html = html;
    this.buttons = buttons;
    this.icon = icon;
    this.classes = classes;
  }

  /**
   * Creates an alert box using SweetAlert.js
   * more info @ https://sweetalert2.github.io/
   *
   *                    button that will close the modal
   * @param options
   */
  show(options = {}) {
    Swal.fire({
      ...options,
      text: this.message,
      content: this.html,
      icon: this.icon,
      showConfirmButton: this.buttons,
      className: this.classes,
    });
  }

  /**
   * Creates an alert box with confirmation choices
   * more info @ https://sweetalert2.github.io/
   *
   *
   * @return {boolean} True if user clicks yes, null if user clicks no.
   * @param options
   */
  showConfirmation(options = {}) {
    if (this.buttons.length === 0) {
      this.buttons = ['No', 'Yes'];
    }

    return Swal.fire({
      ...options,
      text: this.message,
      content: this.html,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    });
  }
}

export { Alert };
